import React from "react";

export default function GridList(props) {
    return (
        <ul className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-6 xl:gap-x-8">
            {props.children}
        </ul>
    );
}

export function GridListItem(props) {
    return <li className="relative z-0">{props.children}</li>;
}
